<div class="flex items-center h-full">
  @switch (appearance()) {
    @case ('light') {
      <img
        src="assets/lions_sm_white.png"
        class="item"
      />
      <img
        src="assets/steelers_sm_white.png"
        class="item"
      />
      <img
        src="assets/strikers_sm_white.png"
        class="item"
      />
    }
    @case ('dark') {
      <img
        src="assets/lions_sm_vendor.png"
        class="item"
      />
      <img
        src="assets/steelers_sm_vendor.png"
        class="item"
      />
      <img
        src="assets/strikers_sm_vendor.png"
        class="item"
      />
    }
  }
</div>
